import React, { useEffect, useState } from "react";
import { axios } from "../../../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import LoadingWithLable from "../../../../../../ReusableComponents/Loading/LoadingWithLable";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FeesPayableEdit from "./FeesPayable";
import MuqeemTableEdit from "./MuqeemTable";

export default function EditFeesAndMuqeem() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [FEES_PAYABLE, SET_FEES_PAYABLE] = useState([]);
  const [MUQEEM_POINTS, SET_MUQEEM_POINTS] = useState([]);
  const { breadCrumbs } = useSelector((state) => state.user);
  const [allowEdit, setAllowEdit] = useState(false);
  const params = useParams();
  const quotationId = params.quotationId;

  const costDivide = (cost, value) => {
    if (cost == 0) return +cost;
    return Math.round(Math.ceil(+cost) / +value);
  };

  const [quotationDetails, setQuotationDetails] = useState({});
  const [costSheetDataLoading, setCostSheetDataLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [costSheetDefault, setCostSheetDefault] = useState({});
  const [selectDatas, setSelectDatas] = useState({});
  // const INITIAL_FEES = {...selectDatas?.quotation_fees_payable};
  // const INITIAL_MUQEEM = {...selectDatas?.quotation_muqeem_point};
  const [INITIAL_FEES, SET_INITIAL_FEES_PAYABLE] = useState([]);
  const [INITIAL_MUQEEM, SET_INITIAL_MUQEEM_POINTS] = useState([]);

  useEffect(() => {
    axios
      .get(`/dashboard/quotation-cost-sheet-module/${quotationId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const result = res.data.data;
        setSelectDatas(result);
        const quotation = result.quotation;
        setQuotationDetails(quotation);
        const allHeadings = result.quotation_cost_sheet_heading;

        setCostSheetDefault(result);
        SET_INITIAL_FEES_PAYABLE(result.quotation_fees_payable);
        SET_INITIAL_MUQEEM_POINTS(result.quotation_muqeem_point);
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      })
      .finally(() => {
        setCostSheetDataLoading(false);
      });
  }, []);

  useEffect(() => {
    const needed_result = generateMuqeem(INITIAL_MUQEEM, MUQEEM_POINTS);
  }, [MUQEEM_POINTS]);

  useEffect(() => {
    const isEditCostSheetInBreadcrumbs = breadCrumbs.some(
      (crumb) => crumb.label === "EDIT FEES PAYABLE & MUQEEM"
    );

    if (!isEditCostSheetInBreadcrumbs) {
      dispatch(
        setBreadCrumb([
          ...breadCrumbs,
          { label: "EDIT FEES PAYABLE & MUQEEM", link: `` },
        ])
      );
    }
  }, [location.pathname, selectDatas]);

  useEffect(() => {
    const allow = allowFeeEdit(INITIAL_FEES, FEES_PAYABLE);
  }, [FEES_PAYABLE, MUQEEM_POINTS]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const FINAL_FEE = generateFeeChanges(INITIAL_FEES, FEES_PAYABLE);
    const FINAL_MUQEEM = generateMuqeem(INITIAL_MUQEEM, MUQEEM_POINTS);
    const body = {
      quotation_id: quotationId,
      fees_payables: FINAL_FEE,
      muqeem_points: FINAL_MUQEEM,
    };

    axios
      .post(
        `/dashboard/quotation-cost-sheet-module-muqeem-fees-payable-action`,
        body,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        dispatch(
          setAppError({
            msg: res?.data?.message || "UPDATED SUCCESSFULLY.",
            color: "success",
          })
        );
        navigate(`/dashboard/quotation/${quotationId}`, {
          state: { method: "View", quotationId: quotationId },
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  return (
    <div className="!uppercase pt-5 pb-10">
      <h2 className="text-2xl text-center font-bold mb-10">
        Quotation Cost Sheet
      </h2>
      {!costSheetDataLoading ? (
        <>
          <div className="text-sm mx-auto max-w-sm">
            <div className="text-left">
              <p>
                <b> Quotation No.</b>: {quotationDetails?.quotation_number}
              </p>
              <p>
                <b>Quotation Name</b> : {quotationDetails?.name}
              </p>
              <p>
                <b>Quotation Type</b> : {quotationDetails?.quotation_type?.name}
              </p>
              <p>
                <b>Client Name</b> : {quotationDetails?.client?.name}
              </p>
              <p
                className={`mb-1 ${
                  quotationDetails?.client?.client_specific?.length < 20
                    ? "flex"
                    : "block"
                }`}
              >
                <b>Client Specific </b> :
                {quotationDetails?.client?.client_specific}
              </p>
            </div>
          </div>

          <div className="flex flex-col w-full gap-1 my-12 overflow-x-scroll px-8 pt-8">
            <form onSubmit={handleSubmit}>
              <FeesPayableEdit
                setAllowEdit={setAllowEdit}
                apiDatas={selectDatas}
                SET_FEES_PAYABLE={SET_FEES_PAYABLE}
              />
              <MuqeemTableEdit
                setAllowEdit={setAllowEdit}
                apiDatas={selectDatas}
                SET_MUQEEM_POINTS={SET_MUQEEM_POINTS}
              />

              <div className="absolute left-1/2 flex  w-full max-w-xs mt-10 gap-4 bottom-5">
                <button
                  className="ring-1 ring-black dark:ring-red uppercase w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
                  type="button"
                  disabled={submitLoading}
                  onClick={() => {
                    navigate(`/dashboard/quotation/${quotationId}`, {
                      state: { method: "View", quotationId: quotationId },
                    });
                  }}
                >
                  CANCEL
                </button>
                <button
                  className="bg-red rounded-md  text-white  p-2 px-10 cursor-pointer text-sm disabled:bg-rose-400"
                  type="submit"
                  disabled={submitLoading || !allowEdit}
                >
                  {submitLoading ? (
                    <LoadingWithLable
                      className={"!mt-0 text-white "}
                      text={"SUBMITTING"}
                    />
                  ) : (
                    `SUBMIT`
                  )}
                </button>
              </div>
            </form>
          </div>
        </>
      ) : (
        <LoadingWithLable />
      )}
    </div>
  );
}

const generateFeeChanges = (
  INITIAL_FEE_PAYABLE,
  FEE_PAYABLE_AFTER_ADD_EDIT_DELETE
) => {
  const desiredOutput = [];
  console.log('FEE_PAYABLE_AFTER_ADD_EDIT_DELETE',FEE_PAYABLE_AFTER_ADD_EDIT_DELETE)
  for (const item of FEE_PAYABLE_AFTER_ADD_EDIT_DELETE) {
    if (item.type && item.type ==='add') {
      desiredOutput.push({
        type: "add",
        item: item.item,
        remark: item.remark,
        cost: item.cost,
      });
    } else {
      desiredOutput.push({
        type: "edit",
        fees_payable_id: item.id,
        item: item.item,
        remark: item.remark,
        cost: item.cost,
      });
    }
  }

  // Compare with INITIAL_FEE_PAYABLE and add "delete" type for missing items
  for (const initialItem of INITIAL_FEE_PAYABLE) {
    const found = desiredOutput.some(
      (item) => item.fees_payable_id === initialItem.id
    );
    if (!found) {
      desiredOutput.push({
        type: "delete",
        fees_payable_id: initialItem.id,
      });
    }
  }

  return desiredOutput;
};

const generateMuqeem = (INITIAL_MUQEEM, MUQEEM_AFTER_ADD_EDIT_DELETE) => {
  const desiredOutput = [];
  for (const item of MUQEEM_AFTER_ADD_EDIT_DELETE) {
    if (item.type && item.type ==='add') {
      desiredOutput.push({
        type: "add",
        particular: item.particular,
        deduction: item.deduction,
        equivalent_sar: item.equivalent_sar,
        paid_by: item.paid_by,
      });
    } else {
      desiredOutput.push({
        type: "edit",
        muqeem_points_id: item.id,
        particular: item.particular,
        deduction: item.deduction,
        equivalent_sar: item.equivalent_sar,
        paid_by: item.paid_by,
      });
    }
  }

  // Compare with INITIAL_MUQEEM and add "delete" type for missing items
  for (const initialItem of INITIAL_MUQEEM) {
    const found = desiredOutput.some(
      (item) => item.muqeem_points_id === initialItem.id
    );
    if (!found) {
      desiredOutput.push({
        type: "delete",
        muqeem_points_id: initialItem.id,
      });
    }
  }
  return desiredOutput;
};

function allowFeeEdit(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return true;
  }

  for (let i = 0; i < arr1.length; i++) {
    const obj1 = arr1[i];
    const obj2 = arr2[i];

    for (const key in obj1) {
      if (obj1[key] !== obj2[key]) {
        return true;
      }
    }
  }

  return false;
}
